import Svg, { Path } from 'react-native-svg'
import { Props } from './type'
export const Calendar = (props: Props) => (
  <Svg viewBox='0 0 25 25' fill='none' {...props}>
    <Path
      d='M7.29167 11.4583H9.375V13.5417H7.29167V11.4583ZM21.875 6.25V20.8333C21.875 21.9792 20.9375 22.9167 19.7917 22.9167H5.20833C4.05208 22.9167 3.125 21.9792 3.125 20.8333L3.13542 6.25C3.13542 5.10417 4.05208 4.16667 5.20833 4.16667H6.25V2.08334H8.33333V4.16667H16.6667V2.08334H18.75V4.16667H19.7917C20.9375 4.16667 21.875 5.10417 21.875 6.25ZM5.20833 8.33334H19.7917V6.25H5.20833V8.33334ZM19.7917 20.8333V10.4167H5.20833V20.8333H19.7917ZM15.625 13.5417H17.7083V11.4583H15.625V13.5417ZM11.4583 13.5417H13.5417V11.4583H11.4583V13.5417Z'
      fill='#FE5000'
    />
  </Svg>
)
